const DatePicker = () => {
  throw new Error("DatePicker is not supported under a native configuration");
};
export default DatePicker;
